import type { SVGProps } from "react";

export function IconBlackPieSlash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.5 4.25C15.5548 4.25 4.25 15.5548 4.25 29.5C4.25 37.9889 8.43889 45.4992 14.8625 50.0768L6.93935 58L7.9994 59.0601L8.52973 58.5297L58.5297 8.52973L59.0601 7.9994L58 6.93933L50.0768 14.8625C45.4992 8.43889 37.9889 4.25 29.5 4.25ZM51.7073 17.4735L40.4308 28.75H54.7515L54.7035 27.9548C54.4753 24.1768 53.4165 20.6229 51.7073 17.4735ZM28.75 40.4308L17.4735 51.7073C20.6229 53.4165 24.1768 54.4753 27.9548 54.7035L28.75 54.7515V40.4308ZM36.1893 28.75L28.75 36.1893V28.75H36.1893Z"
        fill="#23232C"
      />
      <path
        d="M59 34.4661H58.25L59.75 34.4651L59 34.4661ZM59 34.5338L59.75 34.5348L58.25 34.5338H59ZM36.8535 58.8883L36.9247 59.635L36.1035 59.7132V58.8883H36.8535ZM58.874 36.9999V36.2499H59.7039L59.6202 37.0756L58.874 36.9999ZM36.8535 36.9999H36.1035V36.2499H36.8535V36.9999ZM58.25 34.4999C58.25 34.489 58.25 34.478 58.25 34.4671L59.75 34.4651C59.75 34.4767 59.75 34.4883 59.75 34.4999H58.25ZM58.25 34.5328C58.25 34.5218 58.25 34.5109 58.25 34.4999H59.75C59.75 34.5115 59.75 34.5232 59.75 34.5348L58.25 34.5328ZM58.25 34.5338V34.4661H59.75V34.5338H58.25ZM36.7823 58.1417C48.0293 57.0698 56.9899 48.1519 58.1278 36.9243L59.6202 37.0756C58.4101 49.0149 48.8846 58.4951 36.9247 59.635L36.7823 58.1417ZM36.1035 58.8883V36.9999H37.6035V58.8883H36.1035ZM36.8535 36.2499H58.874V37.7499H36.8535V36.2499Z"
        fill="#23232C"
      />
    </svg>
  );
}
